import { memo } from "react";
import { Box, Card, CardActionArea, CardHeader } from "@mui/material";
import Category from "@mui/icons-material/Category";
import Upload from "@mui/icons-material/Upload";
import Dashboard from "@mui/icons-material/Dashboard";
import TextFields from "@mui/icons-material/TextFields";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import ShapeLine from "@mui/icons-material/ShapeLine";
import Wallpaper from "@mui/icons-material/Wallpaper";
import Draw from "@mui/icons-material/Draw";
import { useData } from "../hooks/useData";

const SideToolbar = () => {
  const { setContextualText, setSelectedTool } = useData();

  const handleCategoryClick = () => {
    setContextualText("");
    setSelectedTool("category");
  };

  const handleUploadClick = () => {
    setContextualText("");
    setSelectedTool("upload");
  };

  const handleTemplateClick = () => {
    setContextualText("");
    setSelectedTool("templates");
  };

  const handleTextClick = () => {
    setContextualText("");
    setSelectedTool("text");
  };

  const handlePhotoGalleryClick = () => {
    setContextualText("");
    setSelectedTool("images");
  };

  const handleShapeLineClick = () => {
    setContextualText("");
    setSelectedTool("shapes");
  };

  const handleBackgroundClick = () => {
    setContextualText("");
    setSelectedTool("background");
  };

  const handleDrawClick = () => {
    setContextualText("");
    setSelectedTool("draw");
  };

  return (
    <Box
      sx={{
        width: 100,
        backgroundColor: "#ddd",
        color: "#0d2445",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        p: 1,
        mt: 1,
        ml: 2,
        fontFamily: "Roboto, sans-serif",
      }}
    >
      {[
        {
          icon: <Category />,
          title: "Sign Type",
          onClick: handleCategoryClick,
        },
        { icon: <Upload />, title: "Upload", onClick: handleUploadClick },
        {
          icon: <Dashboard />,
          title: "Templates",
          onClick: handleTemplateClick,
        },
        { icon: <TextFields />, title: "Text", onClick: handleTextClick },
        {
          icon: <PhotoCamera />,
          title: "Images",
          onClick: handlePhotoGalleryClick,
        },
        { icon: <ShapeLine />, title: "Shapes", onClick: handleShapeLineClick },
        {
          icon: <Wallpaper />,
          title: "Background",
          onClick: handleBackgroundClick,
        },
        { icon: <Draw />, title: "Draw", onClick: handleDrawClick },
      ].map((tool, index) => (
        <Card
          key={index}
          elevation={4}
          sx={{
            backgroundColor: "#fff",
            color: "rgba(0, 0, 0, 0.87)",
            height: 80,
            minHeight: 80,
            width: 80,
            mb: 1,
            textAlign: "center",
            "&:hover": { boxShadow: 10, backgroundColor: "#ffffff" },
          }}
        >
          <CardActionArea
            sx={{ "& .MuiTouchRipple-ripple": { color: "blue" } }}
            onClick={tool.onClick}
          >
            <Box sx={{ mt: 2, mb: -1 }}>{tool.icon}</Box>
            <CardHeader
              title={tool.title}
              sx={{
                "& .MuiCardHeader-title": {
                  color: "#000",
                  fontSize: "12px",
                  fontFamily: "Roboto",
                  fontWeight: 500,
                  width: 60,
                  ml: -1,
                  textAlign: "center",
                },
              }}
            />
          </CardActionArea>
        </Card>
      ))}
    </Box>
  );
};

export default memo(SideToolbar);
